import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appFocusScroll]'
})
export class FocusScrollDirective {

  constructor(private element: ElementRef) { }

  @HostListener("focus")
  sortData() { 
    this.element.nativeElement.scrollIntoView();
  }

  
}
